import React from 'react'
import anilogo from '../../assets/GifLogo.gif'
const Loading = () => {
  return (
    <div className='h-60 w-60 m-auto'>
        <img src={anilogo}></img>
    </div>
  )
}

export default Loading